<template>
  <div class="compare" v-if="sonCompareData">
    <div>
      <el-form :inline="true" label-width="140px" style="width: 100%">
        <el-form-item label="分屏模式：">
          <el-select
            v-model="sonCompareData.splitScreenMode"
            placeholder="请选择分屏模式"
          >
            <el-option label="左右" value="leftRight"></el-option>
            <el-option label="上下" value="upDown"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="主屏比例：">
          <el-select
            v-model="sonCompareData.splitScreenModePercentage"
            placeholder="请选择主屏百分比"
          >
            <el-option label="50%" value="50"></el-option>
            <el-option label="占满" value="100"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div style="display: flex; width: 100%; height: 500px; overflow-y: auto">
      <el-form label-width="140px" style="width: 48%">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>主屏配置</span>
          </div>
          <div>
            <div style="">
              <el-collapse class="dual-screen-collapse" v-model="activeNames">
                <el-collapse-item name="show">
                  <template slot="title">
                    <h4>显示操作</h4>
                  </template>

                  <!-- <el-form-item
                    v-for="(x, i) in sonCompareData.mainScreen.show"
                    :key="i"
                    :label="`选择${x.title}`"
                  >
                    <el-cascader
                      v-model="x.model"
                      :options="resourceOptions[i]"
                      :props="{
                        label: 'title',
                        value: 'id',
                        multiple: true,
                        emitPath: false,
                      }"
                      multiple
                      clearable
                      :show-all-levels="false"
                      style="width: 95%;"
                    ></el-cascader>
                  </el-form-item> -->
                  <el-form-item label="">
                    <div
                      v-for="(x, i) in sonCompareData.mainScreen.show"
                      :key="x.id"
                      class="options-tree"
                    >
                      <el-tree
                        v-if="
                          resourceOptions[i][0].children &&
                            resourceOptions[i][0].children.length > 0
                        "
                        show-checkbox
                        default-expand-all
                        node-key="id"
                        :data="resourceOptions[i]"
                        :props="{
                          label: 'title',
                          value: 'id',
                        }"
                        :default-checked-keys="x.model"
                        @check="
                          (data, checked) => {
                            handleCheckChange(
                              data,
                              checked,
                              `optionsTreeMainScreenShow${i}`,
                              x
                            );
                          }
                        "
                        :ref="`optionsTreeMainScreenShow${i}`"
                      ></el-tree>
                      <p class="options-tree-text" v-else>
                        <!-- {{ resourceOptions[i][0].title }} -->
                      </p>
                    </div>
                  </el-form-item>
                </el-collapse-item>
                <el-collapse-item name="hide">
                  <template slot="title">
                    <h4>隐藏操作</h4>
                  </template>
                  <!-- <el-form-item
                    v-for="(x, i) in sonCompareData.mainScreen.hide"
                    :key="i"
                    :label="`选择${x.title}`"
                  >
                    <el-cascader
                      v-model="x.model"
                      :options="resourceOptions[i]"
                      :props="{
                        label: 'title',
                        value: 'id',
                        multiple: true,
                        emitPath: false,
                      }"
                      multiple
                      clearable
                      :show-all-levels="false"
                      style="width: 95%;"
                    ></el-cascader>
                  </el-form-item> -->
                  <el-form-item label="">
                    <div
                      v-for="(x, i) in sonCompareData.mainScreen.hide"
                      :key="x.id"
                      class="options-tree"
                    >
                      <el-tree
                        v-if="
                          resourceOptions[i][0].children &&
                            resourceOptions[i][0].children.length > 0
                        "
                        show-checkbox
                        default-expand-all
                        node-key="id"
                        :data="resourceOptions[i]"
                        :props="{
                          label: 'title',
                          value: 'id',
                        }"
                        :default-checked-keys="x.model"
                        @check="
                          (data, checked) => {
                            handleCheckChange(
                              data,
                              checked,
                              `optionsTreeMainScreenHide${i}`,
                              x
                            );
                          }
                        "
                        :ref="`optionsTreeMainScreenHide${i}`"
                      ></el-tree>
                      <p class="options-tree-text" v-else>
                        <!-- {{ resourceOptions[i][0].title }} -->
                      </p>
                    </div>
                  </el-form-item>
                </el-collapse-item>
                <el-collapse-item name="transparentEnvironment">
                  <template slot="title">
                    <h4>环境透明度</h4>
                  </template>
                  <el-form-item
                    :label="`填写透明度`"
                    v-if="sonCompareData.mainScreen.underground"
                  >
                    <el-input
                      type="number"
                      v-model.number="
                        sonCompareData.mainScreen.underground.opacity.model
                      "
                      max="1"
                      min="0"
                      step="0.1"
                    ></el-input>
                  </el-form-item>
                </el-collapse-item>
                <el-collapse-item name="sectioning">
                  <template slot="title">
                    <h4>模型剖切</h4>
                  </template>
                  <div v-if="sonCompareData.mainScreen.sectioning">
                    <el-form-item
                      :label="`选择方案`"
                      v-if="sonCompareData.mainScreen.sectioning"
                    >
                      <el-select
                        v-model="
                          sonCompareData.mainScreen.sectioning.sectioning.model
                        "
                        multiple
                        placeholder="请选择"
                        style="width: 100%"
                        collapse-tags
                      >
                        <el-option
                          v-for="item in sectioningOptions"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-collapse-item>
                <el-collapse-item name="dyeing">
                  <template slot="title">
                    <h4>模型着色</h4>
                  </template>
                  <div v-if="sonCompareData.mainScreen.dyeing">
                    <Dyeing
                      :configureModel="
                        sonCompareData.mainScreen.dyeing.model.model.x
                      "
                      :resourceOptionsModel="resourceOptions.model"
                      v-model="sonCompareData.mainScreen.dyeing.model.model.y"
                      @dyeingSelectChange="
                        dyeingSelectChange(arguments, 'main')
                      "
                    ></Dyeing>
                  </div>
                </el-collapse-item>
                <el-collapse-item name="terrain">
                  <template slot="title">
                    <h4>地形服务</h4>
                  </template>
                  <div v-if="sonCompareData.mainScreen.terrain">
                    <el-form label-width="140px">
                      <el-form-item :label="`地形服务`">
                        <el-switch
                          v-model="sonCompareData.terrainSwitchMain"
                        ></el-switch>
                      </el-form-item>
                    </el-form>
                  </div>
                </el-collapse-item>

                <el-collapse-item name="roaming">
                  <template slot="title">
                    <h4>漫游</h4>
                  </template>
                  <Roaming
                    v-model="sonCompareData.share.mainScreenRoamingData"
                  ></Roaming>
                </el-collapse-item>
              </el-collapse>
            </div>
          </div>
        </el-card>
      </el-form>
      <el-form label-width="140px" style="width: 48%">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>副屏配置</span>
          </div>
          <div>
            <el-collapse class="dual-screen-collapse" v-model="activeNamesNew">
              <el-collapse-item name="show">
                <template slot="title">
                  <h4>显示操作</h4>
                </template>
                <!-- <el-form-item
                  v-for="(x, i) in sonCompareData.secondaryScreen.show"
                  :key="i"
                  :label="`选择${x.title}`"
                >
                  <el-cascader
                    v-model="x.model"
                    :options="resourceOptions[i]"
                    :props="{
                      label: 'title',
                      value: 'id',
                      multiple: true,
                      emitPath: false,
                    }"
                    multiple
                    clearable
                    :show-all-levels="false"
                    style="width: 95%;"
                  ></el-cascader>
                </el-form-item> -->
                <el-form-item label="">
                  <div
                    v-for="(x, i) in sonCompareData.secondaryScreen.show"
                    :key="x.id"
                    class="options-tree"
                  >
                    <el-tree
                      v-if="
                        resourceOptions[i][0].children &&
                          resourceOptions[i][0].children.length > 0
                      "
                      show-checkbox
                      default-expand-all
                      node-key="id"
                      :data="resourceOptions[i]"
                      :props="{
                        label: 'title',
                        value: 'id',
                      }"
                      :default-checked-keys="x.model"
                      @check="
                        (data, checked) => {
                          handleCheckChange(
                            data,
                            checked,
                            `optionsTreeSecondaryScreenShow${i}`,
                            x
                          );
                        }
                      "
                      :ref="`optionsTreeSecondaryScreenShow${i}`"
                    ></el-tree>
                    <p class="options-tree-text" v-else>
                      <!-- {{ resourceOptions[i][0].title }} -->
                    </p>
                  </div>
                </el-form-item>
              </el-collapse-item>
              <el-collapse-item name="hide">
                <template slot="title">
                  <h4>隐藏操作</h4>
                </template>
                <!-- <el-form-item
                  v-for="(x, i) in sonCompareData.secondaryScreen.hide"
                  :key="i"
                  :label="`选择${x.title}`"
                >
                  <el-cascader
                    v-model="x.model"
                    :options="resourceOptions[i]"
                    :props="{
                      label: 'title',
                      value: 'id',
                      multiple: true,
                      emitPath: false,
                    }"
                    multiple
                    clearable
                    :show-all-levels="false"
                    style="width: 95%;"
                  ></el-cascader>
                </el-form-item> -->
                <el-form-item label="">
                  <div
                    v-for="(x, i) in sonCompareData.secondaryScreen.hide"
                    :key="x.id"
                    class="options-tree"
                  >
                    <el-tree
                      v-if="
                        resourceOptions[i][0].children &&
                          resourceOptions[i][0].children.length > 0
                      "
                      show-checkbox
                      default-expand-all
                      node-key="id"
                      :data="resourceOptions[i]"
                      :props="{
                        label: 'title',
                        value: 'id',
                      }"
                      :default-checked-keys="x.model"
                      @check="
                        (data, checked) => {
                          handleCheckChange(
                            data,
                            checked,
                            `optionsTreeSecondaryScreenHide${i}`,
                            x
                          );
                        }
                      "
                      :ref="`optionsTreeSecondaryScreenHide${i}`"
                    ></el-tree>
                    <p class="options-tree-text" v-else>
                      <!-- {{ resourceOptions[i][0].title }} -->
                    </p>
                  </div>
                </el-form-item>
              </el-collapse-item>
              <el-collapse-item name="transparentEnvironment">
                <template slot="title">
                  <h4>环境透明度</h4>
                </template>
                <el-form-item
                  :label="`填写透明度`"
                  v-if="sonCompareData.secondaryScreen.underground"
                >
                  <el-input
                    type="number"
                    v-model.number="
                      sonCompareData.secondaryScreen.underground.opacity.model
                    "
                    max="1"
                    min="0"
                    step="0.1"
                  ></el-input>
                </el-form-item>
              </el-collapse-item>
              <el-collapse-item name="sectioning">
                <template slot="title">
                  <h4>模型剖切</h4>
                </template>
                <div v-if="sonCompareData.secondaryScreen.sectioning">
                  <el-form-item
                    :label="`选择方案`"
                    v-if="sonCompareData.secondaryScreen.sectioning"
                  >
                    <el-select
                      v-model="
                        sonCompareData.secondaryScreen.sectioning.sectioning
                          .model
                      "
                      multiple
                      placeholder="请选择"
                      style="width: 100%"
                      collapse-tags
                    >
                      <el-option
                        v-for="item in sectioningOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-collapse-item>
              <el-collapse-item name="dyeing">
                <template slot="title">
                  <h4>模型着色</h4>
                </template>
                <div v-if="sonCompareData.secondaryScreen.dyeing">
                  <Dyeing
                    :configureModel="
                      sonCompareData.secondaryScreen.dyeing.model.model.x
                    "
                    :resourceOptionsModel="resourceOptions.model"
                    v-model="
                      sonCompareData.secondaryScreen.dyeing.model.model.y
                    "
                    @dyeingSelectChange="
                      dyeingSelectChange(arguments, 'second')
                    "
                  ></Dyeing>
                </div>
              </el-collapse-item>
              <el-collapse-item name="terrain">
                <template slot="title">
                  <h4>地形服务</h4>
                </template>
                <div v-if="sonCompareData.secondaryScreen.terrain">
                  <el-form label-width="140px">
                    <el-form-item :label="`地形服务`">
                      <el-switch
                        v-model="sonCompareData.terrainSwitchSecond"
                      ></el-switch>
                    </el-form-item>
                  </el-form>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </el-card>
      </el-form>
    </div>
    <!-- </el-scrollbar> -->
  </div>
</template>
<script>
const Roaming = () =>
  import("@/components/tables/program/screenplay/roaming/Index.vue");
const Dyeing = () =>
  import("@/components/tables/program/screenplay/dyeing/index.vue");
// import * as modelCut from "@/components/tables/newModelCut/map.js";
export default {
  name: "compare",
  components: { Roaming, Dyeing },
  props: ["compareData", "configure", "resourceOptions", "sectioningOptions"],
  model: {
    prop: "compareData",
    event: "newFlightData",
  },
  data() {
    return {
      activeNames: null,
      activeNamesNew: null,
      sonCompareData: this.compareData,
      oldConfigure: JSON.parse(JSON.stringify(this.configure)),
      newConfigure: JSON.parse(JSON.stringify(this.configure)),
      // 漫游
      // mainScreenRoamingData: {
      //   radio: "1",
      //   ordinaryId: null,
      //   delay: false,
      //   delayTime: 0,
      // },
    };
  },
  computed: {
    //计算属性将被混入到 Vue 实例中。所有 getter 和 setter 的 this 上下文自动地绑定为 Vue 实例。
    //注意如果你为一个计算属性使用了箭头函数，则 this 不会指向这个组件的实例，不过你仍然可以将其实例作为函数的第一个参数来访问。
  },

  filters: {
    //包含 Vue 实例可用过滤器的哈希表。
  },
  beforeCreate() {
    //在实例初始化之后，数据观测 (data observer) 和 event/watcher 事件配置之前被调用。
  },
  created() {
    //在实例创建完成后被立即调用。在这一步，实例已完成以下的配置：数据观测 (data observer)，property 和方法的运算，watch/event 事件回调。然而，挂载阶段还没开始，el property 目前尚不可用。
  },
  beforeMount() {
    //在挂载开始之前被调用：相关的 render 函数首次被调用。
  },
  methods: {
    // 监听子组件
    dyeingSelectChange(data, type) {
      console.log("监听触发？", data, type);
      if (type == "main") {
        this.sonCompareData.mainScreen.dyeing.model.model.y = data[0];
        this.sonCompareData.mainScreen.dyeing.model.model.x = data[1];
      }
      if (type == "second") {
        this.sonCompareData.secondaryScreen.dyeing.model.model.y = data[0];
        this.sonCompareData.secondaryScreen.dyeing.model.model.x = data[1];
      }
    },
    handleCheckChange(data, checked, type, item) {
      item.model = this.$refs[type][0].getCheckedKeys(true);
    },
  },
  mounted() {
    //实例被挂载后调用，这时 el 被新创建的 vm.el 替换了。如果根实例挂载到了一个文档内的元素上，
    //当 mounted 被调用时 vm.el 也在文档内。
    // this.init();
    if (this.sonCompareData.mainScreen.length == 0) {
      this.sonCompareData.mainScreen = JSON.parse(
        JSON.stringify(this.configure)
      );
      // this.sonCompareData.mainScreen.
    }
    if (this.sonCompareData.secondaryScreen.length == 0) {
      this.sonCompareData.secondaryScreen = JSON.parse(
        JSON.stringify(this.configure)
      );
    }
  },
  watch: {
    // oldConfigure: {
    //   handler(newData, oldName) {
    //     console.log(newData);
    //     this.sonCompareData.mainScreen = newData;
    //   },
    //   deep: true,
    // },
    // newConfigure: {
    //   handler(newData, oldName) {
    //     console.log(newData);
    //     this.sonCompareData.secondaryScreen = newData;
    //   },
    //   deep: true,
    // },
  },
  destroyed() {},
};
</script>
<style lang="scss" scoped>
.compare {
  display: flex;
  flex-direction: column;
  /deep/ .el-card {
    background: transparent;
    border: 1px solid #b0b0b0 !important;
  }
  /deep/ .el-card__header {
    color: rgba(255, 255, 255, 0.9) !important;
    border-bottom: 1px solid #b0b0b0 !important;
  }
  h4 {
    color: rgba(255, 255, 255, 0.9) !important;
  }
  /deep/.el-card__body i {
    color: rgba(255, 255, 255, 0.9) !important;
  }
  /deep/.el-collapse-item__wrap {
    background-color: transparent;
  }
  /deep/.el-collapse {
    border-top: 1px solid #b0b0b0 !important;
  }
  div {
    &::-webkit-scrollbar {
      // 整个滚动条
      width: 0; // 纵向滚动条的宽度
      background: rgba(213, 215, 220, 0.3);
      border: none;
    }
    &::-webkit-scrollbar-track {
      // 滚动条轨道
      border: none;
    }
  }
}
.box-card {
  // width: 100%;
  margin: 0 20px 0 10px;
}
.dual-screen-collapse {
  display: flex;
  flex-wrap: wrap;
  /deep/ .el-collapse-item {
    width: 100%;
  }
  /deep/ .el-collapse-item > div {
    display: flex;
    border-bottom: 1px solid #b0b0b0;
    .el-collapse-item__header {
      display: flex;
      width: 100%;
      flex-direction: row-reverse;
      background-color: transparent;
      border: 0;
    }
    .el-collapse-item__content {
      width: 100%;
    }
  }
  /deep/ .el-tree-node__content:hover {
    background-color: transparent;
  }
  /deep/ .el-form-item {
    margin: 0;
    padding: 20px 0;
  }
  /deep/ .el-collapse-item__content {
    padding-bottom: 0;
  }
}
.options-tree {
  margin-bottom: 15px;
  /deep/ .el-tree {
    background: transparent;
  }
  /deep/ .el-tree-node__label {
    font-size: 16px;
    color: rgba(255, 255, 255, 0.9) !important;
  }
  /deep/ .el-checkbox__inner {
    width: 16px;
    height: 16px;
  }
  /deep/ .el-tree-node__content .el-checkbox__input {
    height: 16px;
  }
  /deep/ .el-tree-node__content > label.el-checkbox {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 0;
    font-size: 16px;
    height: 18px;
    top: 0;
    bottom: 0;
  }
  /deep/ .el-checkbox__inner::after {
    height: 8px;
    left: 5px;
  }
  .options-tree-text {
    line-height: initial;
    margin: 0;
    font-size: 16px;
    padding-left: 50px;
    color: rgba(255, 255, 255, 0.9) !important;
  }
}
</style>
